import React, {useEffect} from "react";
import { Col, Row } from "reactstrap";
import { Image } from 'react-bootstrap' 
import Aos from 'aos'
import MetaTags from 'react-meta-tags' 

import Technology from "assets/images/HeaderImages/Technology.png"

import 'assets/style/Style.css'
 
function LandingPageTech() {
  useEffect( () => {
    Aos.init({ })
  }, [])

  let pageHeader = React.createRef();

  React.useEffect(() => {
    if (window.innerWidth > 991) {
      const updateScroll = () => {
        let windowScrollTop = window.pageYOffset / 3;
        pageHeader.current.style.transform =
          "translate3d(0," + windowScrollTop + "px,0)";
      };
      window.addEventListener("scroll", updateScroll);
      return function cleanup() {
        window.removeEventListener("scroll", updateScroll);
      };
    }
  });
  return (
    <>
      <div className="page-header clear-filter page-header-small">
        <MetaTags>
          <meta name="viewport" content="width=device-width, initial-scale=1.0"></meta>
        </MetaTags>
        <div
          className="page-header-image"
          ref={pageHeader}
        >
          <div className="landing_backgroundimages" >
            <Row>
              <Col>
              <h1 data-aos="fade-right" className='landing_aboutusfont' >Technologies</h1>
              </Col>
              <Col>
              <Image data-aos="fade-up-left" className='landing_contactimage' style={{borderRadius:500}}  src={Technology}/>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </>
  );
}

export default LandingPageTech;
